'use strict';
require('../../company/CompanyService.js');
require('../../company/publications/CompanyPublicationWallDirective.js');
require('../../user/CurrentUserService.js');

function CompanyGuestWallDetailCtrl(
  $scope,
  publication,
  translations,
  $stateParams,
  CompanyPublicationService,
  $sce,
  config,
  activityService
) {
  $scope.publication = publication;
  $scope.translations = translations;
  $scope.activityService = activityService;

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
      'content': '',
      'template': 'partials/company-guest/wall/detail/latest.html',
      'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;

}

CompanyGuestWallDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }]
};
module.exports = CompanyGuestWallDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestWallDetailCtrl', [
  '$scope',
  'publication',
  'translations',
  '$stateParams',
  'CompanyPublicationService',
  '$sce',
  'config',
  'activityService',
  CompanyGuestWallDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/wall/CompanyGuestWallDetailCtrl.js
// module id = 305
// module chunks = 0